import { Auth0Provider } from '@auth0/auth0-react'
import { createRootRoute, Outlet } from '@tanstack/react-router'

import { isMaintenancePeriod, MaintenanceScreen } from '@/components/app/maintenance-screen'
import { MobileDeviceNotice } from '@/components/app/mobile-device-notice'
import { Toaster } from '@/components/ui/toaster'
import { envVariables } from '@/lib/env'

// 旧 app/layout.tsx。html/body・フォント変数・アナリティクスは index.html 側へ移した
// （@vercel/analytics は Vercel専用のため削除。Next.js の Metadata API は使えないため、
// タイトル・OGPは index.html の静的メタタグで代替する）
function RootComponent() {
  if (isMaintenancePeriod()) {
    return <MaintenanceScreen />
  }

  return (
    <Auth0Provider
      domain={envVariables.AUTH0_DOMAIN}
      clientId={envVariables.AUTH0_SPA_APP_CLIENT_ID}
      authorizationParams={{
        redirect_uri: window.location.origin,
      }}
      cacheLocation="localstorage"
    >
      <MobileDeviceNotice />
      <Outlet />
      {/* 操作フィードバック（トースト）の受け皿。呼び出しは @/lib/notify 経由 */}
      <Toaster />
    </Auth0Provider>
  )
}

export const Route = createRootRoute({
  component: RootComponent,
})
